import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import { toast } from '../utils/swal';
import './Login.css';

const Login = ({ onLoginSuccess, onGoToRegister, onForgotPassword }) => {
  const { login, loading } = useAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.password) {
      toast.warning('Email ve şifre gereklidir.');
      return;
    }
    try {
      const user = await login(form.email, form.password);
      toast.success(`Hoş geldiniz, ${user.fullName}!`);
      onLoginSuccess(user);
    } catch (err) {
      toast.error(err.message || 'Giriş başarısız.');
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        {/* Logo */}
        <div className="login-logo">
          <div className="login-logo-icon">🎭</div>
          <h1 className="login-logo-text">Gişe Görevlisi</h1>
          <p className="login-logo-sub">Bilet Rezervasyon Sistemi</p>
        </div>

        {/* Form */}
        <form className="login-form" onSubmit={handleSubmit}>
          <h2 className="login-title">Giriş Yap</h2>

          <div className="login-field">
            <label>Email</label>
            <input
              type="email"
              placeholder="ornek@email.com"
              value={form.email}
              onChange={e => setForm({ ...form, email: e.target.value })}
              autoComplete="email"
              autoFocus
            />
          </div>

          <div className="login-field">
            <label>Şifre</label>
            <div className="login-pass-wrap">
              <input
                type={showPass ? 'text' : 'password'}
                placeholder="••••••••"
                value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
                autoComplete="current-password"
              />
              <button
                type="button"
                className="login-pass-toggle"
                onClick={() => setShowPass(!showPass)}
              >
                {showPass ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          <div className="login-forgot">
            <button type="button" className="login-register-link" onClick={onForgotPassword}>
              Şifremi unuttum
            </button>
          </div>

          <button
            type="submit"
            className="login-btn"
            disabled={loading}
          >
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>
        </form>

        {/* Alt link */}
        <div className="login-footer">
          <span>Hesabınız yok mu?</span>
          <button className="login-register-link" onClick={onGoToRegister}>
            Kayıt Ol
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;